import $ from 'jquery'

import Hub from 'base/hub'
import Event from 'base/event'
import { HEADER_HEIGHT } from 'desktop/containers/layout/header'

function styleContentWrap({ transparentHeader = false }) {
  const paddingAmount = transparentHeader ? 0 : HEADER_HEIGHT

  return $('#content-wrap').css('padding-top', paddingAmount)
}

function adjustHeaderPadding() {
  // Makes the header transparent initially on the homepage (/), the landing page (/land)
  // and referral landing (/r/*)
  const makeHeaderTransparent = [/^\/$/, /\/r\/.+/].some(pattern =>
    pattern.test(window.location.pathname),
  )

  return styleContentWrap({ transparentHeader: makeHeaderTransparent })
}

Hub.sub(Event.App.LAND, adjustHeaderPadding)
Hub.sub(Event.App.ROUTE, adjustHeaderPadding)
Hub.sub(Event.Header.TRANSPARENT_HEADER, (_, options) =>
  styleContentWrap({ transparentHeader: options.isTransparent }),
)
